import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { ILenderTabData, IStateTabData } from './interfaces';

const BASE_URL = `/${SERVICES.DOCUMENT}/titleScan`;

/** State Tab API's */
export const requestCreateState = (data: IStateTabData) => {
	return mutate(BASE_URL, async() => {
		try {
			await axios.post(`${BASE_URL}/state`, data);
			Notistack.successMessage('Title - Created Successfully');
		} catch (err) {
			Notistack.generalError(getError(err));
		}
	});
};

export const requestUpdateState = (data: IStateTabData) => {
	return mutate(`${BASE_URL}/${data?.id}`, async() => {
		try {
			await axios.put(`${BASE_URL}/state/${data?.id}`, data);

			Notistack.successMessage('Title - Updated Successfully');
		} catch (err) {
			Notistack.generalError(getError(err));
		}
	});
};

export const requestDeleteState = (id: string) => {
	return mutate(BASE_URL, async() => {
		try {
			await axios.delete(`${BASE_URL}/state/${id}`);
			
			Notistack.successMessage('Title - Deleted Successfully');
		} catch (err) {
			Notistack.generalError(getError(err));
		}
	});
};

/** Lender Tab API's */
export const requestCreateLender = (data: ILenderTabData) => {
	return mutate(BASE_URL, async() => {
		try {
			await axios.post(`${BASE_URL}/lender`, data);

			Notistack.successMessage('Lender - Created Successfully');
		} catch (err) {
			Notistack.generalError(getError(err));
		}
	});
};


export const requestUpdateLender = (data: ILenderTabData) => {
	return mutate(`${BASE_URL}/${data?.id}`, async() => {
		try {
			await axios.put(`${BASE_URL}/lender/${data?.id}`, data);

			Notistack.successMessage('Lender - Updated Successfully');
		} catch (err) {
			Notistack.generalError(getError(err));
		}
	});
};

export const requestDeleteLender = (id: string) => {
	return mutate(BASE_URL, async() => {
		try {
			await axios.delete(`${BASE_URL}/lender/${id}`);
			
			Notistack.successMessage('Lender - Deleted Successfully');
		} catch (err) {
			Notistack.generalError(getError(err));
		}
	});
};